import { useContext } from 'react';
import { InterimsTimeRangeContext } from '../InterimsTimeRangeContext';

export const useInterimsTimeRange = () => {
  return useContext(InterimsTimeRangeContext);
};
